/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "antd/es/button";
import Form from "antd/es/form";
import Input from "antd/es/input";
import Alert from "antd/es/alert";
import Select from "antd/es/select";
import Skeleton from "antd/es/skeleton";
import Tooltip from "antd/es/tooltip";
import Typography from "antd/es/typography";
import Modal from "antd/es/modal";
import emailjs from "emailjs-com";
import "./index.css";
import mainLogo from "../../assets/logo-bpom.png";
import supabase from "../../utils/supabaseClient";
import downloadJuknis from "../../assets/juknis-crop.png";
import { message } from "antd";
const { Option } = Select;

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSelect, setIsLoadingSelect] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [industries, setIndustries] = useState([]);
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();

  const getDataIndustries = async () => {
    setIsLoadingSelect(true); // Start loading
    try {
      const { data, error } = await supabase
        .from("industries")
        .select()
        .eq("status", 0);
      if (error) {
        throw error;
      }
      setIndustries(data || []);
      setError(false);
    } catch (error) {
      setError(true);
      setErrorMessage("Gagal memuat daftar industri farmasi, coba lagi");
    } finally {
      setIsLoadingSelect(false); // Stop loading once data is fetched or error occurs
    }
  };

  const countDown = () => {
    let secondsToGo = 5;
    const instance = modal.success({
      title: "Berhasil membuat akun",
      content: `Akun anda telah berhasil dibuat, Cek email untuk username dan password yang bisa digunakan untuk login. anda akan redirect ke login page dalam waku: ${secondsToGo} second.`,
      onOk() {
        navigate("/");
      },
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      instance.update({
        content: `Akun anda telah berhasil dibuat, Cek email untuk username dan password yang bisa digunakan untuk login. anda akan redirect ke login page dalam waku: ${secondsToGo} second.`,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      instance.destroy();
      navigate("/");
    }, secondsToGo * 1000);
  };

  useEffect(() => {
    getDataIndustries(); // Call the function to get industries
  }, []); // Empty dependency array to run once on mount

  const sendEmailNotification = async (
    pic_name,
    pic_email,
    username_new,
    password_new
  ) => {
    try {
      await emailjs.send(
        "service_maturitas",
        "template_n1q093g",
        {
          to_name: pic_name,
          email: pic_email,
          message: `Berikut username yang bisa digunakan untuk login dalam Tools Assessment Maturitas Industri Farmasi: `,
          account_info: `Username: ${username_new} 
          
          Password: ${password_new}`,
        },
        "YhZRGHs2OExsm1Poo"
      );
      console.log("Message sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
      throw new Error("Failed to send email notification");
    }
  };

  const updateDatabase = async (values, idx) => {
    const { username_new, password_new, pic_name, pic_email, pic_phone } =
      values;
    const { data, error } = await supabase
      .from("industries")
      .update({
        username: username_new,
        password: password_new,
        status: 1,
        pic_name,
        email: pic_email,
        phone_number: `+62${pic_phone}`,
      })
      .eq("id", idx)
      .select();

    if (error) {
      console.error("Error updating database:", error);
      throw error;
    }

    console.log("Updated Data:", data);
    return data;
  };

  const handleShare = async (pic_email, sheetId, exec_link) => {
    const webAppUrl = `${exec_link}?sheetId=${encodeURIComponent(
      sheetId
    )}&email=${encodeURIComponent(pic_email)}`;

    console.log(exec_link);

    try {
      const response = await fetch(webAppUrl, {
        method: "GET",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        "Access-Control-Allow-Origin": "*",
      });

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Success:", data.message || data.error);
      return data.message || data.error;
    } catch (error) {
      console.error("Error sharing sheet:", error);
      return `Error: ${error.message}`;
    }
  };

  const onFinish = async (values) => {
    const { username_new, pic_name, pic_email, industri_name, password_new } =
      values;
    const [industryWithId, url_industry] = industri_name.split("-separator-");
    const [name_industry, idx] = industryWithId.split("-ids-");
    const sheetId = url_industry.split("/d/")[1]?.split("/")[0] || null;
    const dataIndustry = industries.find(
      (obj) => obj.name_industry === name_industry
    );
    const exec_link =
      dataIndustry && dataIndustry.exec_link ? dataIndustry.exec_link : null;

    console.log("Form values:", values);
    console.log("Industry Name:", name_industry);
    console.log("Industry URL:", url_industry);
    console.log("Industry ID:", idx);
    console.log(dataIndustry);

    setIsLoading(true);
    setError(false);

    try {
      // Send email notification
      await sendEmailNotification(
        pic_name,
        pic_email,
        username_new,
        password_new
      );
      //handle share
      await handleShare(pic_email, sheetId, exec_link);
      // Update database
      await updateDatabase(values, idx);
      // Start countdown if successful
      countDown();
    } catch (error) {
      setError(true);
      setErrorMessage("Mohon maaf, terjadi kesalahan");
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setErrorMessage("Maaf, terjadi kesalahan");
  };

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{
          width: 100,
        }}
        defaultValue="62"
      >
        <Option value="62">+62</Option>
      </Select>
    </Form.Item>
  );

  return (
    <div
      className="container login-container"
      style={{
        margin: "0 5vw",
        maxWidth: "90vw",
      }}
    >
      {contextHolder}
      <div className="row">
        <div
          className="col-md-12 mb-2 pb-2 pt-4"
          style={{ textAlign: "center" }}
        >
          <img src={mainLogo} className="logo-login" alt="fireSpot" />
          <div>
            <h4 className="mt-2 mb-4">
              <a href="">
                <i>Tools Assessment</i> Maturitas Industri Farmasi Tahun 2025
              </a>
            </h4>
            <h4
              style={{
                fontFamily: '"Open Sans", sans-serif',
                color: "#576971",
              }}
            >
              Form Registrasi
            </h4>
            <p
              className="mx-1"
              style={{
                fontFamily: '"Open Sans", sans-serif',
                color: "#576971",
                marginTop: "20vh !important",
              }}
            >
              Daftarkan username dan password untuk mengakses Tools Assessment
              masing masing Industri Farmasi
            </p>
          </div>
        </div>
        <div className="col-md-10">
          {error && (
            <Alert
              message={errorMessage}
              type="error"
              showIcon
              className="mb-2"
            />
          )}
          {!isLoadingSelect ? (
            <>
              <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className="ant-form-horizontal"
                size="large"
                form={form}
              >
                <Form.Item label="Nama Industri Farmasi">
                  <Form.Item
                    name="industri_name"
                    rules={[
                      { required: true, message: "Industry name is required" },
                    ]}
                  >
                    <Select
                      style={{ textAlign: "left", height: "50px" }}
                      showSearch
                      placeholder="Select Industry"
                    >
                      {industries &&
                        industries.length > 0 &&
                        industries.map((item, id) => (
                          <Option
                            key={`test-${id}`}
                            value={`${item.name_industry}-ids-${item.id}-separator-${item.link_industry}`}
                          >
                            {item.name_industry}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Alert
                    message="Jika nama industri farmasi tidak terdapat pada pilihan diatas, kemungkinan akun sudah terdaftar. hubungi narahubung untuk info lebih lanjut. 
                    yusran: +62 852-9998-6777 | syahrul: +62 877-1103-1177 | wasprod.it@gmail.com"
                    type="info"
                    showIcon
                    className="mb-2 mt-2"
                    style={{ textAlign: "left" }}
                  />
                </Form.Item>
                <Form.Item
                  label="Nama PIC"
                  name="pic_name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your pic_name!",
                    },
                  ]}
                >
                  <Input
                    style={{ textAlign: "left", height: "50px" }}
                    placeholder="Masukan Nama PIC"
                  />
                </Form.Item>
                <Form.Item
                  label="Email Gmail PIC"
                  name="pic_email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your E-mail!",
                    },
                    {
                      pattern: /^[a-zA-Z0-9._%+-]+@gmail\.com$/,
                      message: "Email must be a Gmail address!",
                    },
                  ]}
                >
                  <Input
                    style={{ textAlign: "left", height: "50px" }}
                    placeholder="Masukan Email PIC (wajib alamat gmail)"
                  />
                </Form.Item>
                <Form.Item
                  name="pic_phone"
                  label="Phone Number"
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number!",
                    },
                  ]}
                >
                  <Input
                    addonBefore={prefixSelector}
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Username"
                  name="username_new"
                  rules={[
                    {
                      required: true,
                      message: "Please input your username!",
                    },
                  ]}
                >
                  <Input
                    style={{ textAlign: "left", height: "50px" }}
                    placeholder="Buat username baru"
                  />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password_new"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#;])[A-Za-z\d@$!%*?&.#;]{8,}$/,
                      message:
                        "Password harus minimal 8 karakter dan terdiri dari huruf besar, huruf kecil, angka, serta simbol (@$!%*?&.#;)",
                    },
                  ]}
                >
                  <Input.Password
                    style={{ textAlign: "left", height: "50px" }}
                    placeholder="Buat password"
                  />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirm_password_new"
                  rules={[
                    {
                      required: true,
                      message: "Please input your confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password_new") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The new password that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    style={{ textAlign: "left", height: "50px" }}
                    placeholder="Konfirmasi Password"
                  />
                </Form.Item>

                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                  style={{ textAlignLast: "left" }}
                >
                  <Button
                    style={{ textAlign: "left", height: "50px" }}
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                  >
                    Register
                  </Button>
                </Form.Item>
              </Form>
              <Tooltip title="Halaman Login">
                <Typography.Link href="/">
                  Sudah mempunyai akun? klik disini untuk Login
                </Typography.Link>
              </Tooltip>
            </>
          ) : (
            <Skeleton active />
          )}
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-3 mt-4"></div>
        <div className="col-md-6 mt-4">
          <figure class="snip1205 green">
            <img src={downloadJuknis} />
            <i class="ion-android-download"></i>
            <a
              href="https://drive.google.com/file/d/11aSyOYVC2m7uo_ORLOfcQKGB5JcUn4B0/view?usp=drive_link"
              target="_blank"
            ></a>
          </figure>
        </div>
        <div className="col-md-3 mt-4"></div>
      </div>
    </div>
  );
};

export default LoginPage;
